var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCrl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 17.3333C4.39746 17.3333 0.666504 13.6023 0.666504 9C0.666504 4.39762 4.39746 0.666664 8.99984 0.666664C13.6022 0.666664 17.3332 4.39762 17.3332 9C17.3332 13.6023 13.6022 17.3333 8.99984 17.3333ZM8.99984 15.6667C12.6818 15.6667 15.6665 12.6819 15.6665 9C15.6665 5.3181 12.6818 2.33333 8.99984 2.33333C5.31794 2.33333 2.33317 5.3181 2.33317 9C2.33317 12.6819 5.31794 15.6667 8.99984 15.6667ZM8.99984 7.8215L11.3568 5.46446L12.5353 6.64297L10.1783 9L12.5353 11.357L11.3568 12.5355L8.99984 10.1785L6.64281 12.5355L5.4643 11.357L7.82134 9L5.4643 6.64297L6.64281 5.46446L8.99984 7.8215Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCrl);
export default __webpack_public_path__ + "static/media/close-crl.7c5e60fb5ff4006bef64574362404cf5.svg";
export { ForwardRef as ReactComponent };